(function(e) {
    History.Adapter.bind(window,'statechange',function() {
        if (e(".product-listing").length > 0 || e(".filters-row").length > 0) {
            if(!obj.ajaxClickHandlerState) {
                var n = location.search == "" ? "" : "?" + location.search;
                var url = location.pathname + n;
                obj.getCollectionContent(url);
            }
            obj.ajaxClickHandlerState = false;
        }
    });

    var queryParams = {};
    var obj = {
        init: function() {
            queryParams = this.getQueryParams();
            this.initSidebar();
            this.initToolbar();
            this.initShowMore();
            this.currentFilter();
        },
        currentFilter : function(){
            var args = [];
            if(queryParams.constraint ){
                $('.clear_all_filter').show();
                args = queryParams.constraint.split('+');
                $.each(args,function(i,e){
                    $('[value="'+e+'"]').prop('checked',true);
                })
            }
            if(typeof current_collection != typeof undefined && current_collection != 'Products'){
                $('.clear_all_filter').show();
            }
            $(".slider").each(function(){
                var datas = $(this).data('range').split(',');
                var start = datas.length/2;
                $.each(args,function(i,e){
                    if(datas.indexOf(args[i]) >= 0){
                        start = datas.indexOf(args[i]);
                    }
                })
                if(args.length > 0){
                    $("#labels-months-output").text(" " + datas[start]);
                    $('.labels-months-output').val(datas[start]).prop( "checked", true );
                }
                $(this).slider({
                    min: 0,
                    max: datas.length-1,
                    value: start
                }).slider("pips", {}).on("slidechange", function(e,ui) {
                    $("#labels-months-output").text(" " + datas[ui.value]);
                    $('.labels-months-output').val(datas[ui.value]).prop( "checked", true ).trigger('change');
                });
            })
        },
        initSidebar: function() {
            obj.initFiltresEvent();
            obj.initFiltresRemoveEvent();
        },
        initToolbar: function() {
            obj.initSortbyState();
            obj.initSortbyEvent();
            obj.initPerpageEvent();
            obj.initPaginationEvent();
        },
        initShowMore: function() {
            obj.initShowMoreEvent();
        },
        initShowMoreEvent: function() {
            if (e(".show-more a").length > 0) {
                e(".show-more>a").on('click',function(event) {
                    event.preventDefault();
                    if (!e(this).hasClass("disable")) {
                        event.preventDefault();
                        obj.showMoreHandler();
                    }
                })
            }
        },
        showMoreHandler: function() {
            var scrollURL = e('.show-more a').last().attr("href");
            e.ajax({
                type: "GET",
                url: scrollURL,
                beforeSend: function() {
                    obj.showPreloader();
                },
                success: function(data) {
                    if (e(data).find(".product-view").length > 0) {
                        var show_more = '.show-more';
                        e(data).find(".product-view > div").each(function() {
                            e('.product-view').append(e(this));
                        });
                        if(e(data).find('.show-more').length > 0){
                            e(show_more).html(e(data).find(show_more).html());
                        }else{
                            e(show_more).find('a').addClass('disable');
                        }
                        $('body').trigger('convert.money');
                        obj.init();
                        if(e(".spr-badge").length > 0) {
                            e.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
                        }
                    }
                    data = null;
                },
                error: function(XMLHttpRequest, textStatus) {
                    obj.hidePreloader();
                    alert("error");
                },
                dataType: "html"
            })
        },
        initFiltresEvent: function() {
            if (e(".filters-js").length > 0) {
                e('.filters-js:not(.clear-filters) a').unbind().click(function(event) {
                    event.preventDefault();
                    delete queryParams.page;

                    var $_this = e(this);
                    var tag = $_this.attr('href').split('=').pop().split('?').shift();

                    var constraint = queryParams.constraint;
                    queryParams.constraint = constraint ? constraint+'+'+tag : tag;

                    obj.ajaxClick(obj.getAjaxLink(queryParams));
                });
            };
            if ($(".sidebar").length > 0) {
                var filters = $('.block input');
                filters.on('change',function(){
                    obj.getValue();
                });
                $('.clear_all').on('click',function(e){
                    //e.preventDefault();
                    // queryParams.constraint = '';
                    // $('.widget input').prop('checked',false);
                    // obj.ajaxClick(obj.getAjaxLink(queryParams));
                })
            };
        },
        getValue : function(){
            var checked = $('.block input:checked');
            var query = [];
            checked.each(function(){
                query.push($(this).val());
            });
            queryParams.constraint = query.join('+');
            obj.ajaxClick(obj.getAjaxLink(queryParams));
        },
        initFiltresRemoveEvent: function() {
            if (e(".filters-remove-js").length > 0) {
                e('.filters-remove-js a').unbind().click(function(event) {
                    var $_this = e(this);
                    if($_this.hasClass('clear_all')) {
                        delete queryParams.constraint;
                    } else {
                        event.preventDefault();
                        delete queryParams.page;
                        var href = $_this.attr('href');
                        var path = location.pathname;
                        var page = obj.getUrlSubcategory('/collections/', path);
                        var tag = href.split(page).pop().split('/').pop();
                        var arr = [];
                        var arr2 = queryParams.constraint.split('+');
                        $.each(arr2,function(i,e){
                            if(arr2[i] != tag){
                                arr.push(arr2[i]);
                            }
                        })
                        arr != '' ? queryParams.constraint = arr.join('+') : delete queryParams.constraint;
                    }
                    obj.ajaxClick(obj.getAjaxLink(queryParams));
                });
            };
        },
        initSortbyState: function() {
            if (e(".sort-position").length > 0) {
                if (queryParams.sort_by) {
                    e('.sort-position').each(function() {
                        e(this).val(queryParams.sort_by);
                    });
                }
            }
        },
        initSortbyEvent: function() {
            if (e(".sort-position").length > 0) {
                e(document).find('.sort-position').change(function(event) {
                    var val = e(this).val();
                    queryParams.sort_by = val;
                    obj.ajaxClick(obj.getAjaxLink(queryParams));
                });
            }
        },
        initPerpageEvent: function () {
            if (e(".show-qty").length > 0) {
                e(document).find(".show-qty").change(function(event) {
                    var val = e(this).val();
                    if(e(this).find('option:selected').index() == 0) {
                        delete queryParams.view;
                    } else {
                        queryParams.view = val;
                    }
                    delete queryParams.page;
                    obj.ajaxClick(obj.getAjaxLink(queryParams));
                });
            }
        },
        initPaginationEvent: function() {
            if (e(".content-shop .pagination").length > 0) {
                e(".content-shop .pagination a").unbind().click(function(event) {
                    event.preventDefault();
                    if(!e(this).parent().hasClass("active")) {
                        var value = e(this).attr("href").match(/page=\d+/g);
                        if (!value) return false;
                        queryParams.page = parseInt(value[0].match(/\d+/g));
                        obj.ajaxClick(obj.getAjaxLink(queryParams));

                        // var current_class = ".product-view";
                        // var stuck = e('.stuck').length ? e('.stuck').height() : 0;
                        // var top = e(current_class).offset().top - stuck;
                        // e(window).scrollTop(top);
                    }
                });
            };
        },
        getAjaxLink: function(value) {
            var page = obj.getUrlSubcategory('/collections/', location.pathname);
            var pathname = '/collections/' + page;
            value = obj.getDecodedUrl(value);
            return value != "" ? pathname + "?" + value : pathname;
        },
        //AJAX
        ajaxClick: function(url) {
            obj.ajaxClickHandlerState = true;
            History.pushState({
                param: Shopify.queryParams!='constraint='?Shopify.queryParams:''
            }, document.title, url);
            obj.getCollectionContent(url);
        },
        getCollectionContent: function(url) {
            var view = url.match(/view=([^&#]*)/);
            if (!view) {
                url += String(url.indexOf('?') > -1 ?'&':'?') + 'view=ajax';
            }
            else {
                view = view[0];
                url = url.replace(view, view+'ajax');
            }

            var params = {
                type: "get",
                url: url,
                beforeSend: function() {
                    obj.showPreloader();
                },
                success: function(data) {
                    obj.hidePreloader();
                    obj.pageData(data);
                    obj.initPaginationEvent();
                    obj.initSidebar();
                    obj.initShowMore();
                },
                error: function(XMLHttpRequest, textStatus) {
                    obj.hidePreloader();
                    alert("error")
                }
            }
            jQuery.ajax(params);
        },
        //Get and show new content
        pageData: function(data) {
            if(queryParams.constraint){
                $('.clear_all_filter').show();
            }else{
                $('.clear_all_filter').hide();
            }
            //var list_filters = ".sidebar-products-filter";
            var pagination = ".nav-paginate";
            var product_view = ".show-products .row";
            e(product_view).empty();
            e(pagination).empty();
            e('.label-show p').html('');
            e(product_view).html(e(data).find(product_view).html());
            e(pagination).html(e(data).find(pagination).html());
            theme.isotopeCollection();
            $('.sidebar-products-filter').removeClass('active');
            //
            // current_class = ".filtres-js";
            // e(current_class).each(function(index) {
            //     var $_this = e(this);
            //     var $_parent_group = $_this.closest('.collapse-block');
            //
            //     content = e(data).find(current_class+':eq('+index+')');
            //     $_this.replaceWith(content);
            //     content = e(data).find(current_class+':eq('+index+')').closest('.collapse-block');
            //     content.hasClass('hide') ? $_parent_group.addClass('hide') : $_parent_group.removeClass('hide');
            // });
            //
            // content = e(data).find(".product-pagintion");
            // content.length && e.type(content.html()) === "undefined" ? e(".product-pagintion").empty() : e(".product-pagintion").replaceWith(content);
            //
            // content = e(data).find(".number-of-products");
            // e(".number-of-products").replaceWith(content);
            //
            // content = e(data).find('.infinitybutton');
            // e('.infinitybutton').replaceWith(content);
            //
            if ($(document).find('.spr-badge').length > 0){
                e.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            }   //
            //countDown(true);
            //
            // content = null;
            // data = null;
        },
        //Utils
        showPreloader: function() {
            e(".custom-loader").show();
        },
        hidePreloader: function() {
            e(".custom-loader").hide();
        },
        getUrlSubcategory: function (category, url) {
            var str = url;
            var n = str.indexOf(category);
            if(n < 0)
                return "";
            str = str.slice(n + category.length, str.length);
            var m = str.indexOf("/") > -1 ? str.indexOf("/") : str.length;
            str = str.slice(0, m).toLowerCase();
            return str.replace(name+"=", "");
        },
        getQueryParams: function() {
            var location_path = location.pathname;
            var location_search = location.search;
            var path_search = location_path.split('/');
            path_search.length > 3 ? path_search = 'constraint=' + path_search.pop().replace(/&/g, "") : path_search = location_search.split('?').pop();
            if(path_search == '') return {};
            else return obj.uriToJson(path_search);
        },
        uriToJson: function (value) {
            return JSON.parse('{"' + decodeURI(value.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}')
        },
        getDecodedUrl: function(value) {
            return decodeURIComponent($.param(value));
        }
    }

    e(document).ready(function() {
        obj.init();
    });

})(jQuery)